import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type SortableItemProps = {
  id: string;
  className?: string;
  style?: React.CSSProperties;
  inCenter?: boolean;
  isOverlay?: boolean;
};

export const SortableItem: React.FC<SortableItemProps> = ({
  id,
  className = "",
  style = {},
  inCenter = false,
  isOverlay = false,
}) => {
  if (isOverlay) {
    return (
      <div
        className={`card ${className}`}
        style={{
          backgroundColor: "#000",
          color: "#ff0000",
          border: "4px solid #ff0000",
          borderRadius: "12px",
          padding: "10px",
          marginBottom: "10px",
          cursor: "grab",
          width: "100%",
          maxWidth: "200px",
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          ...style,
        }}
      >
        {id}
      </div>
    );
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });
  // For non-overlay, if dragging, force red; otherwise, always white (even for center column)
  const cardColor = isOverlay || isDragging ? "#ff0000" : "#fff";
  const internalStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    color: cardColor,
    border: `4px solid ${cardColor}`,
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...internalStyle, ...style }}
      {...attributes}
      {...listeners}
      className={`card ${className}`}
    >
      {id}
    </div>
  );
};

export default SortableItem;
